import { Content, Heading, VerticalSpace } from '@elhub/ds-components'
import TopContainer from 'components/TopContainer/TopContainer'
import Feedback from '../components/Feedback'
import EnergyData from './changelogs/EnergyData'
import React from 'react'
import { LabelMessages } from '../locales/messages/label'
import { useTranslation } from 'react-i18next'

const ChangeLog = () => {
  const { t } = useTranslation()
  return (
    <TopContainer>
      <Content style={{ maxWidth: '1200px' }}>
        <VerticalSpace size='2' />
        <Heading size='large' spacing>
          {t(LabelMessages.CHANGE_LOG as any)}
        </Heading>
        <VerticalSpace size='2' />
        <EnergyData />
        <VerticalSpace size='2' />
        <Feedback location='EnergyData API Changelog page' />
      </Content>
    </TopContainer>
  )
}

export default ChangeLog
